<template>
  <div>
    <!-- Provincia -->
    <div :class="'mb-3 ' + claseSelects">
      <div class="form-floating">
        <select
          :required="required"
          @change="provinciaSeleccionada($event)"
          v-model="idProvincia"
          class="form-select"
          id="floatingSelectProvincia"
          aria-label="Provincia"
        >
          <option v-bind:value="null">Seleccionar</option>
          <option
            v-for="prov in provincias"
            v-bind:key="prov.id"
            v-bind:value="prov.id"
          >
            {{ prov.nombre }}
          </option>
        </select>
        <label for="floatingSelectProvincia">Provincia</label>
      </div>
    </div>
    <!-- Ciudad -->
    <div :class="claseSelects">
      <div class="form-floating">
        <select
          :required="required"
          @change="localidadSeleccionada($event)"
          v-model="idLocalidad"
          class="form-select"
          id="floatingSelectLocalidad"
          aria-label="Ciudad"
        >
          <option v-bind:value="null">{{ noCityString }}</option>
          <option
            v-for="loc in ciudades"
            v-bind:key="loc.id"
            v-bind:value="loc.id"
          >
            {{ loc.nombre }}
          </option>
        </select>
        <label for="floatingSelectLocalidad">Ciudad</label>
      </div>
    </div>
  </div>
</template>
<script>
import { Api } from "../../api";

/** Cuando la ciudad cambia, ya sea por selección del usuario o por cambio de provincia */
const EVENTO_LOCALIDAD_CAMBIADA = "localidad-cambiada";
const EVENTO_PROVINCIA_CAMBIADA = "provincia-cambiada";

export default {
  props: {
    required: Boolean,
    // Clase que será aplicada a los selects
    claseSelects: String,
    noCityString: {
      type: String,
      default: "Seleccionar",
    },
  },
  data() {
    return {
      idLocalidad: null,
      idProvincia: null,
      ciudades: [],
      provincias: [],
    };
  },
  methods: {
    // Called from outside
    changeLocation(city, province) {
      // Es preferible hacerlo en este orden ya que al cambiar provincia se cargan
      // nuevas ciudades
      if (province) {
        this.cambiarProvincia(province);
      } else {
        // Si pasan ciudad pero no provincia, tratar de seleccionar la provincia por el idProvincia que
        // viene dentro de ciudad
        if (city?.idProvincia) {
          this.seleccionarProvinciaPorId(city.idProvincia);
        }
      }
      this.cambiarLocalidad(city);
    },
    // Métodos internos
    localidadSeleccionada: async function (event) {
      const id = event.target.value;

      const ciudad = this.ciudades.find((l) => l.id == id);
      this.cambiarLocalidad(ciudad);
    },
    provinciaSeleccionada: async function (event) {
      const id = event.target.value;

      const provincia = this.provincias.find((p) => p.id == id);
      this.cambiarProvincia(provincia);

      // Resetear ciudad
      this.cambiarLocalidad(null);
    },
    cambiarLocalidad(ciudad) {
      this.idLocalidad = ciudad != null ? ciudad.id : null;

      this.$emit(EVENTO_LOCALIDAD_CAMBIADA, ciudad);
    },
    cambiarProvincia(provincia) {
      this.idProvincia = provincia?.id;

      if (provincia) {
        this.ciudades = null;
        Api.Localidad.getLocalidadesDeProvincia(provincia.id).then(
          (response) => {
            this.ciudades = response.data;

            // Si hay un idLocalidad, ver si se puede convertir a objeto
            if (this.idLocalidad) {
              const loc = this.ciudades.find((l) => l.id == this.idLocalidad);
              // Si el id corresponde a una de las ciudades cargadas, seleccionarla
              if (loc) this.cambiarLocalidad(loc);
              else
                console.log(
                  "La ciudad elegida no pertenece a la provincia actual"
                );
            }
          }
        );
      }

      this.$emit(EVENTO_PROVINCIA_CAMBIADA, provincia);
    },
    seleccionarLocalidadPorId(id) {
      // Si ya existe un listado de ciudades, seleccionar el objeto correspondiente
      if (id && this.ciudades && this.ciudades.length)
        this.cambiarLocalidad(this.ciudades.find((l) => l.id == id));
      // Guardar id para una futura seleccion cuando se cargue la lista de ciudades
      else this.idLocalidad = id;

      if (this.idLocalidad && !this.idProvincia) {
        Api.Localidad.getProvinciaDeLocalidad(this.idLocalidad).then(
          (response) => this.seleccionarProvinciaPorId(response.data.id)
        );
      }
    },
    seleccionarProvinciaPorId(id) {
      if (id && this.provincias && this.provincias.length)
        this.cambiarProvincia(this.provincias.find((p) => p.id == id));
      // Guardar para una futura carga
      else this.idProvincia = id;
    },
    limpiar() {
      this.idProvincia = null;
      this.idLocalidad = null;
    },
  },
  mounted() {
    Api.Localidad.getProvincias().then((response) => {
      this.provincias = response.data;

      let idASeleccionar;

      if (this.idProvincia) idASeleccionar = this.idProvincia;
      // Si hay una ciudad pero no una provincia, buscar la provincia correspondiente
      else if (this.idLocalidad) {
        Api.Localidad.getProvinciaDeLocalidad(this.idLocalidad).then(
          (response) => (idASeleccionar = response.data.id)
        );
      }

      // Si hay un idASeleccionar, tratar de seleccionar el objeto correspondiente
      if (idASeleccionar) {
        const prov = this.provincias.find((p) => p.id == idASeleccionar);
        if (prov) this.cambiarProvincia(prov);
        else console.log("No se encontró una provincia con el id indicado");
      }
    });
  },
};
</script>